<div
  #trigger
  #origin="cdkOverlayOrigin"
  cdk-overlay-origin
  class="mat-time-picker-trigger"
  [class.time-picker-placeholder]="empty && placeholder"
  tabindex="0"
  role="button"
  [attr.aria-label]="TranslationKeys.AriaLabelTimePickerOpen | translate"
  [attr.aria-expanded]="isPanelOpen"
  (click)="togglePanel()"
  (keydown.enter)="togglePanel()"
  (keydown.space)="togglePanel(); $event.preventDefault()"
>
  {{ triggerValue || '\u00A0' }}
</div>

<ng-template
  cdk-connected-overlay
  cdkConnectedOverlayLockPosition
  cdkConnectedOverlayHasBackdrop
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isPanelOpen"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayOffsetY]="offsetY"
  (backdropClick)="close()"
  (attach)="onAttached()"
  (detach)="close()"
>
  <div class="mat-time-picker-panel-wrap" [class.scalable]="isScalable" [@transformPanelWrap] cdkTrapFocus cdkTrapFocusAutoCapture="true">
    <div
      #panel
      tabindex="-1"
      class="mat-time-picker-panel"
      [@transformPanel]="'opened'"
      (@transformPanel.done)="panelDoneAnimatingStream.next($event.toState)"
      (keydown.escape)="close(); $event.stopPropagation()"
    >
      <div class="mat-time-picker-input-container">
        @if (isDaysEnabled) {
          <input
            #daysInput
            nimbusMatTimeNumber
            spellcheck="false"
            autocomplete="off"
            [attr.aria-label]="TranslationKeys.AriaLabelTimePickerDays | translate"
            [(ngModel)]="valueProcessor.days"
            (wheel)="valueProcessor.onIncreaseDecreaseValue(valuePart.DAY, 1, $event)"
            (blur)="valueProcessor.normalizeValue(valuePart.DAY)"
            (focus)="daysInput.select()"
          />
          <div class="mat-time-picker-input-divider">:</div>
        }
        @if (isHoursEnabled) {
          <input
            #hoursInput
            nimbusMatTimeNumber
            spellcheck="false"
            autocomplete="off"
            [attr.aria-label]="TranslationKeys.AriaLabelTimePickerHours | translate"
            [(ngModel)]="valueProcessor.hours"
            (focus)="hoursInput.select()"
            (ngModelChange)="onHoursValueChanged($event)"
            (wheel)="valueProcessor.onIncreaseDecreaseValue(valuePart.HOUR, 1, $event)"
            (blur)="valueProcessor.normalizeValue(valuePart.HOUR)"
          />
        }

        @if (isMinutesEnabled) {
          <div class="mat-time-picker-input-divider">:</div>
          <input
            #minutesInput
            nimbusMatTimeNumber
            spellcheck="false"
            autocomplete="off"
            [attr.aria-label]="TranslationKeys.AriaLabelTimePickerMinutes | translate"
            [(ngModel)]="valueProcessor.minutes"
            (ngModelChange)="onMinutesValueChanged($event)"
            (wheel)="valueProcessor.onIncreaseDecreaseValue(valuePart.MINUTE, 1, $event)"
            (blur)="valueProcessor.normalizeValue(valuePart.MINUTE)"
            (focus)="minutesInput.select()"
          />
        }

        @if (isSecondsEnabled) {
          <div class="mat-time-picker-input-divider">:</div>
          <input
            #secondsInput
            nimbusMatTimeNumber
            spellcheck="false"
            autocomplete="off"
            [attr.aria-label]="TranslationKeys.AriaLabelTimePickerSeconds | translate"
            [(ngModel)]="valueProcessor.seconds"
            (wheel)="valueProcessor.onIncreaseDecreaseValue(valuePart.SECOND, 5, $event)"
            (blur)="valueProcessor.normalizeValue(valuePart.SECOND)"
            (focus)="secondsInput.select()"
          />
        }
      </div>
      <div class="mat-time-picker-actions">
        <button nimbusInvertedButton (click)="onCancelClick()">{{ TranslationKeys.GeneralCancel | translate }}</button>
        <button nimbusInvertedButton (click)="onSaveClick()" [disabled]="!valueProcessor.isValid">
          {{ TranslationKeys.GeneralSave | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
